import React from "react";

export function checkIfHasData(model) {
  return model.count > 0;
}

export function checkIfHasDataForTimeRange(model) {
  let output = false;
  (model.fields || []).map((reading) => {
    if (
      reading &&
      reading.name &&
      reading.rangemax &&
      reading.rangemin &&
      reading.value
    ) {
      output = true;
    }
    return null;
  });
  return model.count > 0 && output;
}

export function setTimeRange(model) {
  if (model.hours === null || model.hours === undefined) {
    return "(23h)";
  } else if (model.hours === "0") {
    return null;
  } else {
    return "(" + model.hours + "h)";
  }
}

export default function VitalsTile({ model, title }) {
  let hasData = checkIfHasData(model);
  let hasDataForTimeRange = checkIfHasDataForTimeRange(model);
  let timeRange = setTimeRange(model);
  return (
    <React.Fragment>
      <div className="title">
        {title} {timeRange}
        <span className="count">{model.fields.length}</span>
      </div>
      <div className="tile-content vitals">
        {!hasData && !hasDataForTimeRange && (
          <div className="no-results">No Vitals</div>
        )}
        {hasData && !hasDataForTimeRange && (
          <div className="no-results">No Recent Vitals</div>
        )}
        {hasData && hasDataForTimeRange && (
          <table>
            <thead>
              <tr>
                <th></th>
                <th>L</th>
                <td>-</td>
                <th>H</th>
                <td>•</td>
                <th>Rec.</th>
              </tr>
            </thead>
            <tbody>
              {model.fields.map((field, i) => (
                <tr className="field" key={i}>
                  <td className="label">{field.name}</td>
                  <td className="rangemin">{field.rangemin}</td>
                  <td>{field.rangemin ? "-" : null}</td>
                  <td>{field.rangemax}</td>
                  <td>{field.rangemin ? "•" : null}</td>
                  <td>{field.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </React.Fragment>
  );
}
